import { render, staticRenderFns } from "./AzStorage.vue?vue&type=template&id=5457bc3f&"
import script from "./AzStorage.vue?vue&type=script&lang=ts&"
export * from "./AzStorage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports